import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { CompanyService } from '../../../companies/services/company.service';
import { IFila } from '../../data/lista.interface';
import { FilasService } from '../../services/filas.service';

@Component({
  selector: 'app-list-filas',
  templateUrl: './list-filas.component.html',
  styleUrls: ['./list-filas.component.scss']
})
export class ListFilasComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() filas: IFila[] = [];
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };


  constructor(
    private readonly toastService: ToastService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly filaService: FilasService
  ) { }

  public toogleFilaStatus(filaId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} a fila?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.filaService.desativarFila(filaId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.filaService.ativarFila(filaId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }
}
